module.exports = __webpack_public_path__ + "assets/c1636f283bd589fce58c3fdd44d55bb1.mp3";